import React from 'react';
import AOS from 'aos';
import Helmet from 'react-helmet';
import { withPrefix } from 'gatsby-link';

import Banner from '../../components/Banner';
import Themes from '../../components/Themes';
import Portfolios from '../../components/Portfolios';

import './_why-firststep.scss';

class WhyFirstStepPage extends React.Component {

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const isBrowser = typeof window !== 'undefined';
    const AOS = isBrowser ? require('aos') : undefined;
    this.aos = AOS;
    this.aos.init();
  }

  componentDidUpdate() {
    this.aos.refresh();
  }

  render() {

    return (
      <div>
        <Helmet>
          <title>Why FirstStep | Invest as you spend</title>
          <meta name="description" content="Smart technology continues to redefine every relationship we manage in our busy lives including how, where, why, what and when we save. And it just got smarter, safer, and easier with a savvy new platform that offers great returns, lower fees and peace of mind." />
        </Helmet>
        <Banner
          //title="<h1 class='title secondary'>The smartest thing to do <br/> with your money</h1>"
          title="The smartest thing to do with your money"
          //tagline="<p class='tagline'>Smart technology and expertise working <br/>
          //together to grow your savings.</p>"
          tagline="Smart technology and expertise working together to grow your savings."

        />
        <div class="container">

          <div class="card card-banner mx-4">
            <div class="card-body">
              <p class="card-text">Smart technology continues to redefine every relationship we manage in our busy lives including how, where, why, what and when we save. And it just got smarter, safer, and easier with a savvy new platform that offers great returns, lower fees and peace of mind.</p>
              <p class="card-text">Start a very powerful and personal savings crusade today. Save better with a FirstStep investment portfolio and you will always be one step ahead.</p>
            </div>
          </div>

          <section class="content-block text-center">
            <div class="row">
              <div class="col-12">
                <h2>Better than your bank account</h2>
                <table class="table table-bordered table-comparision text-left">
                  <thead>
                    <tr>
                      <td scope="col"></td>
                      <td class="text-uppercase w-25" scope="col">Average Bank</td>
                      <td class="text-uppercase w-40" scope="col">FirstStep Account</td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="align-middle">Projected earnings</td>
                      <td class="align-middle grey">0.85% variable per annum, 0% on everyday accounts</td>
                      <td class="align-middle">
                        <div class="item">
                          <div class="check secondary">
                            <i class="fas fa-check-circle"></i>
                          </div>
                          <div class="info">
                            <p>5.10% per annum (FirstStep Growth)</p>
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td class="align-middle">Fees</td>
                      <td class="align-middle grey">Annual fees, ATM fees, overdraft fees, withdrawal penalties</td>
                      <td class="align-middle">
                        <div class="item">
                          <div class="check secondary">
                            <i class="fas fa-check-circle"></i>
                          </div>
                          <div class="info">
                            <p>$1.25 per month</p>
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td class="align-middle">Education and engagement</td>
                      <td class="align-middle grey">No</td>
                      <td class="align-middle">
                        <div class="item">
                          <div class="check secondary">
                            <i class="fas fa-check-circle"></i>
                          </div>
                          <div class="info">
                            <p>Tips, progress updates on your saving goal</p>
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td class="align-middle">Professional account management</td>
                      <td class="align-middle grey">No</td>
                      <td class="align-middle">
                        <div class="item">
                          <div class="check secondary">
                            <i class="fas fa-check-circle"></i>
                          </div>
                          <div class="info">
                            <p>Yes, every account is expertly managed</p>
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td class="align-middle">Technology</td>
                      <td class="align-middle grey">Built on out of date legacy systems</td>
                      <td class="align-middle">
                        <div class="item">
                          <div class="check secondary">
                            <i class="fas fa-check-circle"></i>
                          </div>
                          <div class="info">
                            <p>Powerful and secure technology</p>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </section>

        </div>

          <section class="what-get" data-aos="fade-up" data-aos-once>
            <div class="wrapper">
              <div class="inner-wrapper">
                <h2 class="text-center">Reach your goals with impact and without complexity</h2>
                <div class="row">
                  <div class="col-md-6">
                    <div class="item">
                      <div class="check">
                        <img src={withPrefix('/images/icons/icon-theme.svg')} alt="Feature icon"/>
                      </div>
                      <div class="info">
                        <h4>Personalise with themes</h4>
                        <p>Invest in seismic trends that drive disproportionate growth in the economy</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="item">
                      <div class="check">
                        <img src={withPrefix('/images/icons/icon-floppy.svg')} alt="Feature icon"/>
                      </div>
                      <div class="info">
                        <h4>Low minimums, low fees</h4>
                        <p>Get started in minutes without hurting the wallet. Start with as little as $1.</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="item">
                      <div class="check">
                        <img src={withPrefix('/images/icons/icon-rising.svg')} alt="Feature icon"/>
                      </div>
                      <div class="info">
                        <h4>Effortlessly save like a genius</h4>
                        <p>Automatically reach your savings goal with recurring deposits and roundups</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="item">
                      <div class="check">
                        <img src={withPrefix('/images/icons/icon-shield.svg')} alt="Feature icon"/>
                      </div>
                      <div class="info">
                        <h4>Securely managed</h4>
                        <p>Our team focus on managing your investments and securing your information</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="item">
                      <div class="check">
                        <img src={withPrefix('/images/icons/icon-search.svg')} alt="Feature icon"/>
                      </div>
                      <div class="info">
                        <h4>Learn as you go</h4>
                        <p>Read tips, guides and lessons so you can save and invest with confidence</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="item">
                      <div class="check">
                        <img src={withPrefix('/images/icons/icon-smartphone.svg')} alt="Feature icon"/>
                      </div>
                      <div class="info">
                        <h4>Fast and enouraging support</h4>
                        <p>Timely saving notifications and friendly support via in-app chat</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <div class="container">
            <section class="content-block text-center">
            <div class="row">
              <div class="col-12">
                <h2>Powered by industry veterans</h2>
              </div>
            </div>

            <div class="row align-items-center justify-content-center">
              <div class="col-12 col-sm-4">
                <div class="partner-tile">
                  <div class="img-container">
                    <img className="img-fluid" src={withPrefix('/images/logos/industry-partners/EQT.png')} alt="Equity Trustees logo" />
                  </div>
                  <h5 class="tile-title">Equity Trustees</h5>
                  <h6 class="tile-caption">Responsible Entity</h6>
                  <a class="tile-link" href="http://www.eqt.com.au/" target="_blank" rel="noopener" aria-label="Visit Equity Trustees website">Learn More</a>
                </div>
              </div>

              <div class="col-12 col-sm-4">
                <div class="partner-tile">
                  <div className="img-container">
                    <img className="img-fluid w-75" src={withPrefix('/images/logos/industry-partners/AET.png')} alt="AET logo" />
                  </div>
                  <h5 class="tile-title">Australian Executor Trustees</h5>
                  <h6 class="tile-caption">Independent Custodian</h6>
                  <a class="tile-link" href="http://www.aetlimited.com.au/" target="_blank" rel="noopener" aria-label="Visit AET website">Learn More</a>
                </div>
              </div>

              <div class="col-12 col-sm-4">
                <div class="partner-tile">
                  <div className="img-container">
                    <img className="img-fluid" src={withPrefix('/images/logos/industry-partners/prime-financial.png')} alt="Prime Financial logo" />
                  </div>
                  <h5 class="tile-title">Prime Financial</h5>
                  <h6 class="tile-caption">Licensee</h6>
                  <a class="tile-link" href="http://www.primefinancial.com.au/" target="_blank" rel="noopener" aria-label="Visit Prime Financial website">Learn More</a>
                </div>
              </div>

            </div>
            </section>
          </div>

      </div>
    );
  }
}

export default WhyFirstStepPage;



// WEBPACK FOOTER //
// ./src/pages/why-firststep/index.js